import { init } from "@jsq/observability";

export const initObservability = ({ appName }: { appName: string | undefined }) => {
  init({
    applicationId: __DATADOG_RUM_APP_ID__,
    clientToken: __DATADOG_RUM_CLIENT_TOKEN__,
    serviceName: appName ? `main/${appName}` : undefined,
    version: __JSQ_COMMIT_HASH__,
  });
};
